/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';

import { apiConfig } from '@pages/OrganizationProfile/config/api.config';
import { updateProfileConfig } from '@pages/OrganizationProfile/config/updateProfile.config';
import { UPDATE_MY_ORGANIZATION } from '@pages/OrganizationProfile/api/graphql';

const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUpdateProfilePluginMethods extends IPluginMethodMap {
  getUpdateProfile(args?: any): Promise<any>;
}

export class UpdateProfilePlugin implements IAgentPlugin {
  readonly methods: IUpdateProfilePluginMethods;
  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    return {
      //products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    //try {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = getWhoamiSrv()?.getToken();
    // const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .mutation(UPDATE_MY_ORGANIZATION, {
            name: args?.name,
            description: args?.description,
            primaryContactNo: args?.telephone,
            website: args?.website,
            address: {
              addressLine1: args?.address,
              city: args?.city,
              country: args?.country,
            },
            logo: args?.logo?.base64,
          })
          .toPromise();
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      // log.log('result of update profile=', res?.data?.capsules);
      log.error('error in update profile=', err?.message);
      throw err;
    }
  }

  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
